export const getVatIncValue = (price: number, siPercentage: number) => {
  if (!siPercentage) return price;
  const vatInc = price * (siPercentage / 100);
  return price + vatInc;
};

// computation for this may change
export const getVat2307Value = (price: number, siPercentage: number) => {
  if (!siPercentage) return price;
  return getVatIncValue(price, siPercentage) * 0.99; // decrease by 1%
};
